import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useCallback } from 'react';
const composerPromptHistoryEvent = EVENT_PAYLOAD;
export function usePromptHistoryAnalytics({ track, surface, }) {
    return useCallback((event) => {
        track(composerPromptHistoryEvent({
            name: 'composer prompt history event',
            data: {
                action: event.action,
                surface,
                history_size: event.historySize,
                ...(event.direction ? { direction: event.direction } : {}),
                selected_index: event.selectedIndex,
            },
        }));
    }, [surface, track]);
}
//# sourceMappingURL=usePromptHistoryAnalytics.js.map